import React, { useState } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
  Stack,
  Box,
} from "@mui/material";
import { useAppDispatch } from "@store/index";
import Datepicker from "@atoms/datepicker";
import { completeActivity } from "@pages/shippingView/shippingSlice";

const CompleteDialog = ({
  sid,
  activityId,
  handleClose,
}: {
  sid: number;
  activityId: number;
  handleClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const [date, setDate] = useState<string | null>(null);

  const handleComplete = () => {
    dispatch(
      completeActivity(sid, activityId, {
        completion_date: date as string,
        execution_date: date as string,
      }),
    );
    handleClose();
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      maxWidth={"sm"}
      fullWidth={true}
      PaperProps={{
        sx: {
          overflow: "visible",
        },
      }}
    >
      <DialogTitle>Complete Activity</DialogTitle>
      <DialogContent>
        <Stack gap={2}>
          <Box>
            You are about to mark this shipping activity as completed. Please
            specify the completion date to finalize this step.
          </Box>
          <Box>
            <Datepicker
              start={null}
              selectsRange={false}
              label="Completion Date"
              onChangeCallback={(date: string | null) => setDate(date)}
              width="100%"
              size="medium"
            />
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button onClick={handleClose} color="primary">
          Back
        </Button>
        <Button disabled={!date} variant="contained" onClick={handleComplete}>
          Complete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteDialog;
